import type { AbilityBuilder } from '@casl/ability'
import type { AppAbility } from '~/types/authorization.type'
import type { User } from '~/types/user.type'
import { userRoles } from '../roles'

export function defineGlobalSearchAbilities(abilityBuilder: AbilityBuilder<AppAbility>, user: User) {
  const { can, cannot } = abilityBuilder

  can('read', 'global-search')

  const roles = userRoles(user)

  if (!roles.administrator && !roles.client_lead)
    cannot('read', 'global-search', 'withCompleted')
}
